import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { createHtmlElement } from '../../utils/index'

export default class Policy extends Component {
  render () {
    const { policy, show } = this.props
    return (
      <li id={policy.slug} className={show ? 'policy-list-item active' : 'policy-list-item'}>
        <div className='policy-content' dangerouslySetInnerHTML={createHtmlElement(policy.content_html)}></div>
      </li>
    )
  }
}

Policy.propTypes = {
  show: PropTypes.bool,
  policy: PropTypes.object
}
